import React from "react";
import { Row, Col, Container, Label, Input } from "reactstrap";
import { NumberField, CounterpartySuggest, TradingRoutes, DateTimeField } from "./FormFields";
import style from "./Trading.module.scss";

const LineForm = ({
  row,
  needFX,
  FXPair,
  loading,
  delRow,
  fetchCParties,
  tradeRoutes,
  onChange,
  massiveMode,
  maxDecimals,
}) => {
  const errors = row.errors || {};
  return (
    <div className={style.line}>
      <Container>
        {row.orderId && row.orderId > 0 && (
          <Row>
            <Col lg="12" style={{ display: "flex" }}>
              <span>
                Order <b>#{row.orderId}</b>
                {row.tradeId && row.tradeId > 0 ? (
                  <span>
                    {" "}
                    (Trade <b>#{row.tradeId}</b>)
                  </span>
                ) : null}
              </span>
            </Col>
          </Row>
        )}
        <Row>
          <Col lg="12" style={{ display: "flex" }}>
            <NumberField
              value={parseFloat(row.quantity)}
              label={"Quantity"}
              error={errors.quantity}
              disabled={loading || row.quantityDisabled}
              onChange={(v) => onChange({ quantity: v })}
              tabIndex="0"
              dataTypeDecimalName="quantity"
            />

            <span className={style.arroba}>@</span>

            <NumberField
              value={parseFloat(row.price)}
              label={"Price"}
              error={errors.price}
              disabled={loading || massiveMode || row.disabled}
              onChange={(v) => onChange({ price: v })}
              tabIndex="0"
              decimalScale={maxDecimals}
              dataTypeDecimalName="price"
            />

            {needFX && (
              <NumberField
                value={parseFloat(row.fx)}
                label={`FX (${FXPair})`}
                error={errors.fx}
                disabled={loading || row.disabled}
                onChange={(v) => onChange({ fx: v })}
                style={{ marginLeft: "8px" }}
                tabIndex="0"
                dataTypeDecimalName="currency"
              />
            )}
          </Col>
        </Row>
        {(!massiveMode || row.disabled) && ( // if row is disabled, show the counterparty and trading route
          <React.Fragment>
            <Row>
              <Col lg="12" className={style.sndRow}>
                <CounterpartySuggest
                  value={row.counterpartyName}
                  disabled={loading || row.disabled}
                  onChange={(v) => onChange(v)}
                  error={errors.counterpartyId}
                  fetchItems={fetchCParties}
                />{" "}
                <TradingRoutes
                  style={{ marginLeft: "14px" }}
                  value={row.route}
                  error={errors.route}
                  disabled={loading || row.disabled}
                  onChange={(id) => onChange({ route: id })}
                  tradeRoutes={tradeRoutes}
                  autoWidth
                />
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <DateTimeField
                  label={"Date time"}
                  step="1"
                  error={errors.date}
                  disabled={loading || row.disabled}
                  value={row.date}
                  onChange={(v) => onChange({ date: v })}
                  inputStyle={{ width: "292px" }}
                  tabIndex="0"
                />
              </Col>
            </Row>
          </React.Fragment>
        )}
        <Row>
          <Col lg="8" style={{ display: "flex", marginLeft: "20px" }}>
            <Input
              type="checkbox"
              checked={row.source}
              value={row.source}
              onClick={(e) =>
                onChange({
                  source: !row.source,
                })
              }
              inputStyle={{ width: "10px" }}
            />
            {"Source"}
          </Col>
        </Row>
      </Container>
      {!massiveMode && !row.disabled && (
        <span className={style.deleteBtn} onClick={() => delRow()}>
          <i className="fa fa-trash" aria-hidden="true"></i>
        </span>
      )}
    </div>
  );
};

export default LineForm;
